export class TheCryptGameConfig {
    public static reel_num: number = 6;
    public static reelsNum: number = 6;
    public static symbolsNumOnReel: number = 6;
    public static MSymbolCollectorLevels: number = 4;
    public static M1CollectorLevels: number = 1;
    public static reelHeight: number = 600;
    public static symbolHeight: number = 150;
    public static symbolWidth: number = 120;
    public static defaultGameAreaSize: number[] = [4, 4, 4, 4, 4, 4];
    public static reelAreaPos: PIXI.Point = new PIXI.Point(58, 80);
    public static reelAreaMaskPos: PIXI.Point = new PIXI.Point(0, 0);
    public static reelPositions: PIXI.Point[] = [
        new PIXI.Point(0, 0),
        new PIXI.Point(0 + TheCryptGameConfig.symbolWidth, 0),
        new PIXI.Point(0 + TheCryptGameConfig.symbolWidth * 2, 0),
        new PIXI.Point(0 + TheCryptGameConfig.symbolWidth * 3, 0),
        new PIXI.Point(0 + TheCryptGameConfig.symbolWidth * 4, 0),
        new PIXI.Point(0 + TheCryptGameConfig.symbolWidth * 5, 0),
        new PIXI.Point(0 + TheCryptGameConfig.symbolWidth * 6, 0)
    ];
    public static DEFAULT_WAYS: number = 4096;
    public static SYMBOL_HIGHLIGHT_DURATION: number = 0.2;
}